import { render } from "./CommunityRecruitmentDashboard.vue?vue&type=template&id=463b9266&scoped=true"
import script from "./CommunityRecruitmentDashboard.vue?vue&type=script&lang=js"
export * from "./CommunityRecruitmentDashboard.vue?vue&type=script&lang=js"

import "./CommunityRecruitmentDashboard.vue?vue&type=style&index=0&id=463b9266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463b9266"]])

export default __exports__